import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { UIKitModule } from '@vendasta/uikit';
import { UserProfileModule } from '@vendasta/user-profile';
import { VFormModule } from '@vendasta/vform';
import { AccountRoutingModule } from './account-routing.module';
import { AccountComponent } from './account.component';

@NgModule({
  imports: [
    VFormModule,
    UIKitModule,
    MatCardModule,
    CommonModule,
    UserProfileModule,
    GalaxyPageModule,
    TranslateModule,
    AccountRoutingModule,
  ],
  declarations: [AccountComponent],
})
export class AccountModule {}
